import { IAppMedlogicState } from '@medlogic/medlogic/medlogic-shared-interfaces';
import { IActivity, IActivityTypeCodeableConcept, LogService } from '@medlogic/shared/shared-interfaces';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { withLatestFrom, mergeMap, catchError, of, map, switchMap } from 'rxjs';
import { loadActivities, loadActivitiesSuccess, activityFail, loadActivityTypes, loadActivityTypesSuccess, setIsLoadingActivity } from './activity.actions';
import { FhirActivityService } from '../../service/fhir-activity.service';
import { FhirActivityTypeService } from '../../service/fhir-activity-type.service';

@Injectable()
export class ActivityEffects {

  constructor(
    private actions$: Actions,
    private store: Store<IAppMedlogicState>,
    private activitySrv: FhirActivityService,
    private activityTypeSrv: FhirActivityTypeService,
    private log: LogService
  ) { }

  loadActivities$ = createEffect(() => this.actions$
    .pipe(
      ofType(loadActivities),
      withLatestFrom(this.store),
      mergeMap(([_, state]) => {
        return this.activitySrv.getActivitiesByPatientId<IActivity[]>(state.patient.selectedId)
      }),
      switchMap((activities: IActivity[] | null) => {
        return activities ? [loadActivitiesSuccess({ activities }), setIsLoadingActivity({ isLoading: false })] : [activityFail({ method: 'loadActivities', error: 'Erro ao carregar as atividades' }), setIsLoadingActivity({ isLoading: false })]
      }
      ),
      catchError((e: any) => {
        console.log(e);
        return of(activityFail({ method: 'loadActivities', error: e?.message || e }));
      }),
    )
  );

  loadActivityTypes$ = createEffect(() => this.actions$
    .pipe(
      ofType(loadActivityTypes),
      withLatestFrom(this.store),
      mergeMap(() => this.activityTypeSrv.getAll<IActivityTypeCodeableConcept[]>()),
      map((activityTypes: IActivityTypeCodeableConcept[] | null) =>
        activityTypes ? loadActivityTypesSuccess({ activityTypes }) : activityFail({ method: 'loadActivityTypes', error: 'Erro ao carregar os tipos de atividades' })
      ),
      catchError((e: any) => {
        console.log(e);
        return of(activityFail({ method: 'loadActivityTypes', error: e?.message || e }));
      })
    )
  );

  activityFail$ = createEffect(() => this.actions$.pipe(
    ofType(activityFail),
    withLatestFrom(this.store),
    map(([action, state]) => {
      this.log.Registrar(this.constructor.name, action?.method, action?.error, state?.tenant?.tenantId);

      return setIsLoadingActivity({ isLoading: false });
    })
  ));
}
